<template>
  <v-layout
    align-center
    justify-space-between
    wrap
  >
    <v-flex
      xs12
      class="sz-list-header page-content-paddings"
      :style="{ 'background-color': background }"
    >
      <v-layout
        align-center
        justify-space-between
      >
        <v-layout
          v-if="!$vuetify.breakpoint.xsOnly"
          align-center
          justify-start
        >
          <AppLogo
            v-if="showLogo"
            class="mr-2"
          />
          <h1 class="display-4 mr-2">
            {{ pageTitle }}
          </h1>
        </v-layout>
        <AppLogo v-else />
        <v-layout
          align-center
          none-growth
        >
          <mobileBtn v-if="$vuetify.breakpoint.xsOnly" />
          <accountMenu v-else />
        </v-layout>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      class="page-content-paddings"
    >
      <v-layout
        :justify-end="!$vuetify.breakpoint.xsOnly"
        :justify-space-between="$vuetify.breakpoint.xsOnly"
        align-center
        mt-3
      >
        <h1
          v-if="$vuetify.breakpoint.xsOnly"
          class="display-4 mr-2"
        >
          {{ pageTitle }}
        </h1>
        <div v-if="showBtn">
          <v-btn
            v-if="addFamilyPermission === true"
            color="sz_violet"
            class="mx-0"
            :class="[{ 'pr-2 pl-1': mobileScreen }]"
            append
            :to="{ name: 'add-family' }"
          >
            <v-icon>add</v-icon>
            {{ btnTitle }}
          </v-btn>
        </div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';
import mobileBtn from '@/components/widgets/menu/MainMenuMobileBtn';
import accountMenu from '@/components/widgets/account/AccountMenu';
import Permissions from '@/constants/permissions';

export default {
    name: 'ListPagesHeader',
    components: {
        AppLogo,
        mobileBtn,
        accountMenu
    },
    props: {
        pageTitle: {
            type: String,
            required: true
        },
        showBtn: {
            type: Boolean,
            default: true
        },
        showLogo: {
            type: Boolean,
            default: false
        },
        background: {
            type: String,
            default: '#fff'
        }
    },
    data () {
        return {
            addFamilyPermission: null
        };
    },
    computed: {
        btnTitle () {
            if (this.$vuetify.breakpoint.xsOnly) {
                return this.$t('buttons.add');
            } else {
                return this.$t('buttons.add_family');
            }
        },
        mobileScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        }
    },
    mounted () {
        this.$store.dispatch('auth/hasPermission', Permissions.FAMILY_EDITION_ADD).then((data) => {
            this.addFamilyPermission = data;
        });
    }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_variables.scss';

@media (max-width: $xs) {
  .theme--light.v-btn.sz_violet {
    min-width: 77px;
    width: 77px;
    flex-shrink: 0;
  }
}
</style>
